<template>
  <div class="cash-withdrawal">
    <div class="cash-withdrawal-from">
      <div class="my-card-title">提现</div>
      <div class="my-form">
        <form>
          <div class="form-item">
            <label>当前积分</label>
            <div class="can-drawal-num">
              <p><i>{{ integral }}</i>积分</p>
            </div>
          </div>
          <div class="form-item">
            <label>可提现金额</label>
            <div class="can-drawal-num">
              <p><i>{{ commission }}</i>元</p>
            </div>
          </div>
          <div class="form-item">
            <label></label>
            <div class="fs12 colorBlue ">提现规则：1积分可兑换{{ config.ratio }}元</div>
          </div>
          <div class="form-item">
            <label>提现金额</label>
            <div class="input-group">
              <el-input type="text" style="width:200px" placeholder="请输入提现金额" v-model="form.price">
                <template slot="append">元</template>
              </el-input>

            </div>
          </div>
          <div class="form-item">
            <label></label>
            <div class="fs12 colorRed ">提示：{{ config.alert }}</div>
          </div>
          <div class="form-item">
            <label>到账银行卡</label>
            <el-row>
              <el-col :span="10">
                <el-select placeholder="请选择提现账号" style="width:300px;" v-model="form.user_account_id">
                  <el-option v-for="(item, index) in accountList" :key="index"
                    :label="`${item.account}（${item.method_name}）`" :value="item.id"> </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-button @click="addBankCard" class="add-btn"><i>+</i>添加银行卡</el-button>
              </el-col>
            </el-row>
          </div>

          <div class="form-item">
            <label></label>
            <el-button type="submit" class="my-btn" :loading="loading" @click="handleWithdraw">立即提现</el-button>
          </div>
        </form>
      </div>
    </div>
    <!-- 新建账户 -->
    <add-account :visible.sync="showAddForm" @getList="getAllAccountList" />
  </div>
</template>

<script>
import { getWithdrawPreview, setSubmit } from "@/api/withdraw";
import { getAllAccountList } from "@/api/account";
import AddAccount from "./components/addAccount"

export default {
  name: 'WithdrawIndex',
  components: {
    AddAccount
  },
  data() {
    return {
      loading: true,
      accountList: [],
      integral: 0,
      commission: 0,
      config: {},
      form: {
        user_account_id: null,
        price: null
      },
      showAddForm: false,
    };
  },
  computed: {

  },
  created() {
    this.getAllAccountList();
    this.getWithdrawPreview();
  },
  methods: {
    getWithdrawPreview() {
      getWithdrawPreview({}).then(res => {

        this.loading = false;
        this.integral = res.data.integral;
        this.commission = res.data.commission;
        this.config = res.data.config
      }).catch((err) => {

      });
    },
    getAllAccountList() {
      getAllAccountList({}).then(res => {
        this.accountList = res.data;
        this.form.user_account_id = res.data ? res.data[0].id : 0
      }).catch((err) => {

      });
    },
    addBankCard() {
      this.showAddForm = true
    },
    // 提现
    handleWithdraw() {
      const _form = JSON.parse(JSON.stringify(this.form))
      if (_form.price < this.config.limit) {
        this.$message.error('提现金额不能大于可提现金额!');
        return false
      }
      if (_form.price > this.commission) {
        this.$message.error('提现金额不能大于可提现金额!');
        return false
      }
      this.loading = true;
      setSubmit(_form).then((response) => {
        this.loading = false;
        this.getWithdrawPreview();
        // 弹出操作提示
        this.$message({
          type: 'success',
          message: '申请成功，请等待管理员审核!'
        });
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/withdraw.less"
</style>
